import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, Periode,
  ExtraUitgavenKledingEnBeddengoed,
  PGASpecifiekeZorgkosten, AangifteRapport, IncomeTaxEntity, BokkzAlgDataService
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule, DatePipe } from '@angular/common';
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-extra-uitgaven-kleding-en-beddengoed',
  templateUrl: './extra-uitgaven-kleding-en-beddengoed.component.html',
  styleUrls: ['./extra-uitgaven-kleding-en-beddengoed.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDetailsModule,
        CommonModule,
        SharedUiTooltipModule
    ],
  providers: [DatePipe]
})
export class ExtraUitgavenKledingEnBeddengoedComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    grensBedrag = 0;

    public aangifteRapport = {} as AangifteRapport;

    private focusedElementId: string | null = null;
    public extraUitgavenKledingEnBeddengoed = {} as FormGroup

    public aftrekLabel = '';

    public itemsDuurZiekte: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Langer dan een jaar"},
        {value: false, label: "Korter dan een jaar"}
    ];

    bepaalGrensBedrag() {
        if (this.incomeTaxEntity.year === 2024) {
            this.grensBedrag = 700
        }
        if (this.incomeTaxEntity.year === 2025) {
            this.grensBedrag = 680
        }
        if (this.incomeTaxEntity.year === 2026) {
            this.grensBedrag = 660
        }
    }

    public itemsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Uitgaven hoger dan grensbedrag"},
        {value: false, label: "Uitgaven lager dan grensbedrag"}
    ];

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder,
                private dataPipe: DatePipe) {
        this.extraUitgavenKledingEnBeddengoed = this.fb.group({
            pgaExtraUitgavenKledingEnBeddengoed:
                this.fb.array<PGASpecifiekeZorgkosten>([])
        })
    }

    get pgaExtraUitgavenKledingEnBeddengoed(): FormArray {
        return this.extraUitgavenKledingEnBeddengoed.get('pgaExtraUitgavenKledingEnBeddengoed') as FormArray;
    }

    getPeriodeFormGroup(index: number): FormGroup {
        const periode = this.pgaExtraUitgavenKledingEnBeddengoed.at(index) as FormGroup;
        return periode.get('periode') as FormGroup;
    }

    addRijExtraUitgavenKledingEnBeddengoed(): void {
        this.pgaExtraUitgavenKledingEnBeddengoed.push(this.createExtraUitgavenKledingEnBeddengoedFormGroup()
        )
    }

    verwijderRijExtraUitgavenKledingEnBeddengoed(index: number): void {
        this.pgaExtraUitgavenKledingEnBeddengoed.removeAt(index);
        this.extraUitgavenKledingEnBeddengoed.updateValueAndValidity()
        this.extraUitgavenKledingEnBeddengoed.markAsDirty()
        this.saveForm()
    }



    createExtraUitgavenKledingEnBeddengoedFormGroup(extra?: ExtraUitgavenKledingEnBeddengoed): FormGroup {
        return this.fb.group(({
            duurZiekteMinimaalJaar: extra ? extra.duurZiekteMinimaalJaar : undefined,
            extraUitgavenKledingBeddengoedHogerDanMax: extra ? extra.extraUitgavenKledingBeddengoedHogerDanMax : undefined,
            periode: this.fb.group(({
                begindatum: extra?.periode ? extra.periode.begindatum : [new Date(this.aangifte.aangifteJaar, 0, 1, 12, 0, 0)] as unknown as Date,
                einddatum: extra?.periode ? extra.periode.einddatum : [new Date(this.aangifte.aangifteJaar, 11, 31, 12, 0, 0)] as unknown as Date
            } as Periode))
        } as ExtraUitgavenKledingEnBeddengoed))
    }

    public ngOnInit(): void {
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm();
                this.bepaalGrensBedrag()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving&& this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.extraUitgavenKledingEnBeddengoed.dirty;
  }

  private updateForm(): void {
        const extraUitgavenKledingEnBeddengoedLijst = this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.extraUitgavenKledingEnBeddengoed || [];
        const formArray = this.extraUitgavenKledingEnBeddengoed.get('pgaExtraUitgavenKledingEnBeddengoed') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > extraUitgavenKledingEnBeddengoedLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < extraUitgavenKledingEnBeddengoedLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(extraUitgavenKledingEnBeddengoedLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createExtraUitgavenKledingEnBeddengoedFormGroup(extraUitgavenKledingEnBeddengoedLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            const uitgaven = this.extraUitgavenKledingEnBeddengoed.value.pgaExtraUitgavenKledingEnBeddengoed as ExtraUitgavenKledingEnBeddengoed[]
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaSpecifiekeZorgkosten: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                        extraUitgavenKledingEnBeddengoed: uitgaven
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }
}
